<template>
  <div class="gw-box shadow">
		<div class="gw-box-header center">
			<h4>Contact</h4>
		</div>
		<div class="gw-box-body">
			<p>
				<label class="contact-label-width">Email:</label>
				<span><a href="mailto:duo@windsuponastring.com">duo@windsuponastring.com</a></span>
			</p>
			<p>
				<label class="contact-label-width">Phone:</label>
				<span><a href="tel:4109695789">410-969-5789</a></span>
			</p>
			<p>
				<label class="contact-label-width">Facebook:</label>
				<span><a href="http://www.facebook.com/WindsUponAString" target="_blank">WindsUponAString</a></span>
			</p>
			<p>
				<label class="contact-label-width">Twitter:</label>
				<span><a href="http://www.twitter.com/AimeeOnTheHarp" target="_blank">AimeeOnTheHarp</a></span>
			</p>
			<p>
				<span>Write a review on <a href="https://www.theknot.com/marketplace/aimeeontheharp-glen-burnie-md-728801" target="_blank">TheKnot</a> or <a href="https://www.weddingwire.com/shared/rate/new?vid=af7fd18c6a4f7da0" target="_blank">WeddingWire</a>!</span>
			</p>
		</div>
	</div>
</template>

<script>

export default {
	
	name: 'Contact',
	
  data () {
    return {
    }
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
